import config from "@/config"
import http from "@/utils/request"

export default {
  menu: {
    // myMenus: {
    //   // url: `${config.API_URL}/system/menu/my/1.6.1`,
    //   url: `${config.API_URL}/manage/menu/list`,
    //   name: "获取我的菜单",
    //   get: async function () {
    //     return await http.get(this.url)
    //   }
    // },
    list: {
      url: `${config.API_URL}/manage/menu`,
      name: "获取菜单",
      type: "menu",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/submit`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      }
    }
  },
  dic: {
    tree: {
      url: `${config.API_URL}/system/dic/tree`,
      name: "获取字典树",
      get: async function () {
        return await http.get(this.url)
      }
    },
    list: {
      url: `${config.API_URL}/system/dic/list`,
      name: "字典明细",
      get: async function (params) {
        return await http.get(this.url, params)
      }
    },
    get: {
      url: `${config.API_URL}/system/dic/get`,
      name: "获取字典数据",
      get: async function (params) {
        return await http.get(this.url, params)
      }
    }
  },
  role: {
    list: {
      url: `${config.API_URL}/role`,
      name: "获取角色列表",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      updateRolePermission: async function (data) {
        return await http.post(`${this.url}/updateRolePermission`, data)
      },
      updateRoleMenu: async function (data) {
        return await http.post(`${this.url}/updateRoleMenu`, data) // 更新角色菜单
      },
      getRoleMenu: async function (data) {
        return await http.post(`${this.url}/getRoleMenuByRoleId`, data) // 获取角色菜单
      },
      getSelfMenus: async function (data) {
        return await http.post(`${this.url}/getSelfMenus`, data) // 获取角色菜单
      }
    }
  },
  permission: {
    list: {
      url: `${config.API_URL}/permission`,
      name: "获取角色列表",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      }
    }
  },
  dept: {
    list: {
      url: `${config.API_URL}/system/dept/list`,
      name: "获取部门列表",
      get: async function (params) {
        return await http.get(this.url, params)
      }
    }
  },
  user: {
    list: {
      url: `${config.API_URL}/system/user/list`,
      name: "获取用户列表",
      get: async function (params) {
        return await http.get(this.url, params)
      }
    }
  },
  app: {
    list: {
      url: `${config.API_URL}/system/app/list`,
      name: "应用列表",
      get: async function () {
        return await http.get(this.url)
      }
    }
  },
  log: {
    list: {
      url: `${config.API_URL}/system/log/list`,
      name: "日志列表",
      get: async function (params) {
        return await http.get(this.url, params)
      }
    }
  },
  table: {
    list: {
      url: `${config.API_URL}/system/table/list`,
      name: "表格列管理列表",
      get: async function (params) {
        return await http.get(this.url, params)
      }
    },
    info: {
      url: `${config.API_URL}/system/table/info`,
      name: "表格列管理详情",
      get: async function (params) {
        return await http.get(this.url, params)
      }
    }
  },
  tasks: {
    list: {
      url: `${config.API_URL}/system/tasks/list`,
      name: "系统任务管理",
      get: async function (params) {
        return await http.get(this.url, params)
      }
    }
  }
}
